export default "/assets/images/the-basic-breather-crop.png?570bfa7306c2a0fd8389ba6779540994";